import app from "../_app";
import {quantitiesInit} from "./quantity";

const cart = document.querySelector('.js-cart');

if(cart) {
    const cartItemCount = document.querySelector('.js-cart-item-count');
    const cartDiscount = document.querySelector('.js-cart-discount');
    const cartDiscountAmount = document.querySelector('.js-cart-discount-amount');
    const cartDiscounts = document.querySelector('.js-cart-discounts');
    const cartTotalPrices = document.querySelectorAll('.js-cart-total-price');
    const cartInner = document.querySelector('.js-cart-inner');
    const cartEmpty = document.querySelector('.js-cart-empty');
    const cartQuantityFields = [...document.querySelectorAll('.js-quantity')];
    const cartCheckouts = [...document.querySelectorAll('.js-cart-checkout')];
    const microcartItemCount = document.querySelector('.js-microcart-notification');

    cartQuantityFields.map(quantity => quantitiesInit(quantity, false));

    const handleQuantityUpdate = (eventData) => {
        const { items, item_count, total_price, cart_level_discount_applications } = eventData;

        if (item_count === 0) {
            cartCheckouts.map(cartCheckout => cartCheckout.setAttribute('disabled', ''));
            cartEmpty.classList.remove('d-none');
            cartInner.classList.add('d-none');
            cartItemCount.classList.add('d-none');
        }

        // Bundles put several cart lines behind the same parent variant, so rows are matched on
        // their line key rather than on the variant.
        const remainingKeys = items.map(item => item.key);
        const removedProducts = [...document.querySelectorAll('.js-cart-product')]
            .filter(cartProduct => remainingKeys.includes(cartProduct.querySelector('.js-quantity-input').dataset.key) === false);

        removedProducts.map(removedProduct => removedProduct.remove());

        const variantIds = items.map(item => item.variant_id);

        const variantRequests = variantIds.map(variantId => {
            return fetch(`/variants/${variantId}.js`).then(response => response.json());
        });

        Promise.all(variantRequests)
          .then(variants => {
              let totalDiscount = 0;
              let hasDiscountedItems = false;

              items.forEach(item => {
                  const variant = variants.find(variant => variant.id === item.variant_id);
                  const compareAtPrice = variant ? variant.compare_at_price : 0;
                  const price = item.price;

                  if (compareAtPrice > price) {
                      hasDiscountedItems = true;
                      const discount = compareAtPrice - price;
                      totalDiscount += discount * item.quantity;
                  }
              });

              microcartItemCount.setAttribute('data-amount', item_count);
              cartItemCount.innerText = item_count;

              cartTotalPrices.forEach((cartTotalPrice) => {
                  cartTotalPrice.innerText = app.currency(total_price);
              })

              let totalCartLevelDiscount = 0;

              if (cart_level_discount_applications.length > 0) {
                  cartDiscounts.classList.remove('d-none');
                  cartDiscounts.innerHTML = cart_level_discount_applications.map(cartDiscount => {
                      const discountAmount = cartDiscount.discount_application.total_allocated_amount;
                      totalCartLevelDiscount += discountAmount;  

                      return `
                          <div class="cart__summary-row fw-500 d-grid">
                              <span>${cartDiscount.discount_application.title}</span>
                              <span class="c--b">-${app.currency(discountAmount)}</span>
                          </div>
                      `;
                  }).join('').replace(/\n\s+/g, '');
              }

              const combinedDiscount = totalDiscount + totalCartLevelDiscount;

              if (!hasDiscountedItems && combinedDiscount === 0) {
                  cartDiscount.remove();
              } else {
                  cartDiscountAmount.innerText = `- ${app.currency(combinedDiscount)}`;
              }
          }
        );
    }
    
    const cartCheckoutClickHandler = () => {
        cartCheckouts.map(cartCheckout => {
            cartCheckout.setAttribute('data-state', 'loading');
            setTimeout(() => cartCheckout.setAttribute('disabled', ''));
        });
    }

    window.addEventListener('quantity.updated', (event) => handleQuantityUpdate(event.detail));
    cartCheckouts.map(cartCheckout => cartCheckout.addEventListener('click', cartCheckoutClickHandler));
}

